import { get } from './Global';

// 绑定手机号
export const getTaskPublicityList = (pageNo: number, pageSize: number) => {
    return get("/way/publicity/list", {
        pageNo,
        pageSize
    });
    // console.log(pageNo, pageSize)
    // return new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //         let publicityTasksTemp = [];
    //         for (let i = 0; i < 20; i ++) {
    //             publicityTasksTemp.push(        {
    //                 taskId: Math.random(),
    //                 uid: 'holz***yu@163.com',
    //                 applicant: '郑**',
    //                 publicCountdown: 3507800
    //             })
    //         }
    //         resolve({
    //             code: 200,
    //             result: {
    //                 result: publicityTasksTemp,
    //                 //@ts-ignore
    //                 currentPage: pageNo,
    //                 pageCount: 10,
    //                 //@ts-ignore
    //                 pageNo: pageNo + 1
    //             }
    //         })
    //     }, 30000)
    // })
}

export interface IInquireTask {
    uid?: string,
    safePhone?: string
    code?: string
}

export const getInquireTaskPublicity = ({ uid, safePhone, code }: IInquireTask) => {
    let params:IInquireTask = {};
    uid && (params.uid = uid);
    safePhone && (params.safePhone = safePhone);
    code && (params.code = code)
    return get("/way/publicity/info", params);
}

export const getAccountExplainCheck = (taskId: number, uid: string) => {
    return get("/way/publicity/check", {
        taskId,
        uid
    });
}
